import React from "react";
import { Avatar } from "@logora/debate.user.avatar";
import { GroupLabel } from "@logora/parliament.parliament_group.group_label";
import styles from "./MemberBox.module.scss";

export interface MemberProps {
  /** Member first name */
  firstName: string;
  /** Member last name */
  lastName: string;
  /** Image URL */
  imageUrl?: string;
  /** Extra className */
  className?: string | undefined;
  /** Size variant */
  size?: "small" | "medium" | "large";
  /** On click callback */
  onClick?: () => null;
  /** Show parliament group */
  parliamentGroup?: ParliamentProps;
  /** Show member chamber */
  chamber?: string;
  /** Text boldness */
  isBold?: boolean;
  /** Layout variant */
  layout?:
    | "default"
    | "groupFirst"
    | "stacked"
    | "oneLine"
    | ("default" | "groupFirst" | "stacked" | "oneLine")[];
}

interface ParliamentProps {
  color: string;
  groupName: string;
  className?: string;
}

export const MemberBox = ({
  firstName = "",
  lastName = "",
  imageUrl,
  size = "medium",
  onClick,
  parliamentGroup = undefined,
  chamber = undefined,
  className = undefined,
  isBold = true,
  layout = "default",
}: MemberProps) => {
  const userName = `${firstName} ${lastName}`;
  const layoutClasses = Array.isArray(layout)
    ? layout.map((l) => styles[l]).join(" ")
    : styles[layout];

  return (
    <div
      className={`${styles.container} ${
        styles[size]
      } ${className} ${layoutClasses} ${onClick && styles.click}`}
      onClick={onClick}
    >
      {imageUrl && (
        <Avatar
          avatarUrl={imageUrl?.trim()}
          userName={userName}
          className={styles.avatar}
        />
      )}
      <div className={styles.nameContainer}>
        <span className={styles.name}>
          {firstName}{" "}
          <span className={isBold ? styles.boldText : ""}>{lastName}</span>
        </span>
        {parliamentGroup?.groupName && (
          <div className={styles.labelContainer}>
            {parliamentGroup?.groupName && (
              <GroupLabel
                color={parliamentGroup.color}
                groupName={parliamentGroup.groupName}
                chamber={chamber}
                size="small"
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
